import { InjectionToken } from '@angular/core';

export const WIDGET_CONTEXT_ID = new InjectionToken<string>('WIDGET_CONTEXT_ID', {
  factory: (): string => 'no-context',
});
